import clsx from 'clsx';
import { motion } from 'framer-motion';

export const Tab = (props) => {
	const { name, isActive = false, onClick } = props;

	return (
		<button
			onClick={onClick}
			className={clsx(
				isActive ? 'selected' : '',
				'relative border-none px-3 py-1'
			)}>
			{name}
			{isActive ? (
				<motion.div
					layoutId='underline'
					className='absolute bottom-0 left-0 right-0 h-[2px] bg-primary-800'
				/>
			) : null}
		</button>
	);
};

export const MobileTab = (props) => {
	const { id, name, isActive = false, onClick } = props;

	return (
		<li key={id}>
			<button
				onClick={onClick}
				className={clsx(
					isActive ? 'underline' : '',
					'text-xl font-medium text-primary-800 hover:text-gray-500'
				)}>
				{name}
			</button>
		</li>
	);
};
